import React from "react";
import { ContentTemplate } from "../../../types/stylepacks";
import { CapsuleItem, convertCapsuleVariablesToApi, Providers, StylePacksTypes, updateContentTemplate } from "./titles-add-utils";
import { useDispatch } from "react-redux";
import { loadGenerateContentTemplates } from "../../../../stores/actions/generate-content";
import { parse } from "path";

const GeneratedContentTemplates = (props: {content: ContentTemplate, token:string}) => {
    const [type, setType] = React.useState<string>(props.content.type);
    const [content_type, setContentType] = React.useState<StylePacksTypes>(props.content.contentType as unknown as StylePacksTypes ?? StylePacksTypes.TITLE); 
    const [video_url, setVideoUrl] = React.useState<string>(props.content.videoUrl ?? "");
    const [thumbnail_url, setThumbnailUrl] = React.useState<string>(props.content.thumbnailUrl ?? "");
    const [name, setName] = React.useState<string>(props.content.name);
    const [locked, setLocked] = React.useState<boolean>(props.content.locked);
    const [style_pack, setStylePack] = React.useState<string>(props.content.stylePack);
    const [provider, setProvider] = React.useState<Providers>(props.content.provider as Providers);
    const [data, setData] = React.useState<string>(JSON.stringify(props.content.data, null, 2) ?? "{}");
    const [showDetails, setShowDetails] = React.useState<boolean>(false);
    const dispatch = useDispatch();
    const {content, token} = props;


    return (
        <div key={content.id}>
            <strong>{content.id}</strong>
            <div>{content.name}</div>
            <div>{content.type}</div>
            <button onClick={()=>{
                setShowDetails(!showDetails);
            }}>{showDetails? 'HIDE DETAILS': 'SHOW DETAILS'}</button>
            {showDetails && <div> 
                <li>
                    <div>Current Type: {content.contentType}</div>
                    <select
                        onChange={async (e) => {
                                const newType = e.target.value;
                                setContentType(newType as StylePacksTypes);
                                await updateContentTemplate(content.id, {content_type: newType as StylePacksTypes}, token);
                                // Dispatch action to update the content template in the store
                                if(token) {
                                    dispatch(loadGenerateContentTemplates(token));
                                }
                            }
                        }
                        value={content_type}
                    >
                        <option value={StylePacksTypes.TITLE}>Title</option>
                        <option value={StylePacksTypes.WALKUP}>Walkup</option>
                        <option value={StylePacksTypes.SEGMENT}>Segment</option>
                        <option value={StylePacksTypes.COUNTDOWN}>Countdown</option>
                        <option value={StylePacksTypes.BOOKEND}>Bookend</option>
                        <option value={StylePacksTypes.SLIDE}>Slide</option>
                        {/* Add other options as needed */} 
                    </select>
                </li>
                <li>
                    <strong>Current Video URL</strong>
                    <div>{content.videoUrl}</div>
                    <input 
                        type="text"
                        value={video_url}
                        onChange={(e) => {
                            setVideoUrl(e.target.value);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {video_url}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}> UPDATE DEFAULT VIDEO URL</button>
                </li>
                <li>
                    <strong>Current Thumbnail URL</strong>
                    <div>{content.thumbnailUrl}</div>
                    <input 
                        type="text"
                        value={thumbnail_url}
                        onChange={(e) => {
                            setThumbnailUrl(e.target.value);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {thumbnail_url}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}> UPDATE DEFAULT IMAGE THUMBNAIL URL</button>
                </li>
                <li>
                    <strong>Current Name</strong>
                    <div>{content.name}</div>
                    <input 
                        type="text"
                        value={content.name}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {name}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE NAME</button>
                </li>
                <li>
                    <strong>Locked</strong>
                    <div>{content.locked ? 'true' : 'false'}</div>
                    <input
                        type="checkbox"
                        checked={locked}
                        onChange={(e) => {
                            setLocked(e.target.checked);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {locked}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE LOCKED</button>
                </li>
                <li>
                    <strong>Style Pack</strong>
                    <div>{content.stylePack}</div>
                    <input 
                        type="text"
                        value={style_pack}
                        onChange={(e) => {
                            setStylePack(e.target.value);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {style_pack}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE STYLE PACK</button>
                </li>
                <li>
                    <strong>Provider</strong>
                    <div>{content.provider}</div>
                    <input 
                        type="text"
                        value={provider}
                        onChange={(e) => {
                            setProvider(e.target.value as Providers);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {provider}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE PROVIDER</button>
                </li>
                <li>
                    <strong>Data</strong>
                    <div>{JSON.stringify(content.data)}</div>
                    <textarea name="data" value={data} 
                    onChange={(e)=>setData(e.target.value)}/> 
                    <button onClick={async (e) => {
                            const parsedData = convertCapsuleVariablesToApi(JSON.parse(data) as unknown as [CapsuleItem], content_type as StylePacksTypes)
                            await updateContentTemplate(content.id, {data:parsedData, content_type}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE DATA (SAVING ALSO UPDATES THE CONTENT_TYPE)</button>
                </li>
                <li>
                    <strong>Current Template</strong>
                    <div>{content.type}</div>
                    <input 
                        type="text"
                        value={type}
                        onChange={(e) => {
                            setType(e.target.value as StylePacksTypes);
                        }}
                    />
                    <button onClick={async (e) => {
                            await updateContentTemplate(content.id, {type}, token);
                            // Dispatch action to update the content template in the store
                            if(token) {
                                dispatch(loadGenerateContentTemplates(token));
                            }
                        }}>UPDATE TEMPLATE</button>
                </li>
            </div>}
        </div>
    )
};

export default GeneratedContentTemplates;